/**
 * Singleton holding mutable, non-reactive state used to correlate admission
 * transactions across the admit-flow lifecycle
 */
class AdmissionTrackingHistory {
  private static instance: AdmissionTrackingHistory | null = null;
  private transactionId: string | null = null;

  private constructor() {}

  static getInstance(): AdmissionTrackingHistory {
    if (!AdmissionTrackingHistory.instance) {
      AdmissionTrackingHistory.instance = new AdmissionTrackingHistory();
    }
    return AdmissionTrackingHistory.instance;
  }

  setTransactionId(transactionId: string): void {
    this.transactionId = transactionId;
  }

  getTransactionId(): string | null {
    return this.transactionId;
  }
}

export const admissionTrackingHistory = AdmissionTrackingHistory.getInstance();
